import React, {useCallback, useRef, useEffect} from 'react';
import 'pages/Consultancy/components/testimonial.css'
import {testimonials} from "data/ConsultancyTestomonial";
import TestimonialCard from "pages/Consultancy/components/TestimonialCard";
import ArrowIcon from "compoments/icons/ArrowIcon";

function TestimonialInfo() {
    const testimonialRef = useRef(null);
    const scrollAmount = 400; // Scroll 400px to the right or left

    // Function to scroll the container horizontally
    const scroll = useCallback((direction) => {
        if (testimonialRef.current) {
            testimonialRef.current.scrollBy({
                left: direction === 'next' ? scrollAmount : -scrollAmount,
                behavior: 'smooth'
            });
        }
    }, []);

    const scrollNext = useCallback(() => scroll('next'), [scroll]);
    const scrollPrev = useCallback(() => scroll('prev'), [scroll]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (testimonialRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } = testimonialRef.current;
                if (scrollLeft + clientWidth >= scrollWidth - 10) {
                    testimonialRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    testimonialRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                }
            }
        }, 3500);

        return () => clearInterval(interval);
    }, []);

    return (
        <section className='testimonial-section' style={{position: 'relative'}}>
            <div className="container">
                <div className="testimonial">
                    <h1>Personal Journeys</h1>
                    <h4 className='text-center fw-bold offering-title'>
                        How Natural Living Has Supported Real Transformation
                    </h4>

                    <div className="all-testimonial mt-5" style={{
                        display: 'flex',
                        overflowX: 'auto',
                        scrollSnapType: 'x mandatory',
                        gap: '20px',
                    }} ref={testimonialRef}>

                        {testimonials.map((testimonial) => (
                            <TestimonialCard
                                key={testimonial.id}
                                id={testimonial.id}
                                imageSrc={testimonial.imageSrc}
                                name={testimonial.name}
                                subText={testimonial.subText}
                                excerpt={testimonial.excerpt}
                                scrollSnapAlign="start"
                                flexBasis="33%"
                            />
                        ))}
                    </div>
                </div>
            </div>

            <button onClick={scrollPrev} className="arrow-btn left-arrow">
                <ArrowIcon direction="left" section={"testimonials"}/>
            </button>
            <button onClick={scrollNext} className="arrow-btn right-arrow">
                <ArrowIcon direction="right" section={"testimonials"}/>
            </button>
        </section>
    );
}

export default TestimonialInfo;
